import { Application } from "pixi.js"
import { loadSpritesheet } from "./spritesheet"
import { SCREEN_HEIGHT, SCREEN_WIDTH, SHOW_CONSOLE, USE_SHADER } from "./config"
import { initConsole } from "./Console"
import { CRTFilter } from "pixi-filters"
import Game from "./Game"

import { WebSocketManager } from "./WebSocketManager"

export async function initGame(
  ws: WebSocketManager,
  assets: { tileset: string }
): Promise<Game> {
  const app = new Application()

  await app.init({
    background: "0x000000",
    width: SCREEN_WIDTH,
    height: SCREEN_HEIGHT,
  })

  if (USE_SHADER) {
    app.stage.filters = [
      new CRTFilter({
        curvature: 10,
        lineWidth: 0.5,
        lineContrast: 0.35,
        noise: 0.1,
        verticalLine: false,
        noiseSize: 1.5,
        vignetting: 0.4,
        vignettingAlpha: 0.1,
        vignettingBlur: 0.3,
        time: 12,
      }),
    ]
  }

  const canvasContainer = document.querySelector("#canvas-container")
  if (canvasContainer) {
    canvasContainer.appendChild(app.canvas)
  }

  await loadSpritesheet(assets.tileset)

  const game = new Game({ app, ws })

  if (SHOW_CONSOLE) {
    initConsole(app.stage)
  }

  app.ticker.maxFPS = 60
  app.ticker.add((ticker) => {
    game.tickUpdate(ticker)
  })

  return game
}
